<template>
<div>
    <template v-if="onspecials.length">
        <h3 class="columnTit"><span>今日在拍</span><a href="/preauction" target="_blank">查看更多</a></h3>
        <div class="swipe-item-wrap" >
          <div
            class="swipe-item"
            v-for="(item, itemIndex) in onspecials"
            :key="itemIndex"
            @click="
              jumpSession(item)"
          >
            <div

              :class="[
                'focus-wrap',
                item.bid_type === 1 && item.bid_status == 2
                  ? 'focus-wrap-active'
                  : '',
              ]"
            >
              <div
                :class="[
                  'focus-picture',
                  item.type === 2 && item.bid_type === 1 && item.bid_type === 2
                    ? 'focus-picture-small'
                    : '',
                ]"
              >
                <div v-if="item.cultural_license" class="tag-wrap">
                  <lottie
                    v-if="item.status === 4"
                    class="tag-wenwu"
                    :options="jingpaiOptions"
                    :height="115"
                    :width="124"
                  />
                  <lottie
                    v-if="item.status === 5"
                    class="tag-wenwu"
                    :options="jieshuOptions"
                    :height="115"
                    :width="124"
                  />
                  <lottie
                    v-if="item.status === 1"
                    class="tag-wenwu"
                    :options="yuzhanOptions"
                    :height="115"
                    :width="124"
                  />
                </div>
                <div class="tag-wrap" v-else>
                  <div
                    :class="[
                      'tag-list',
                      item.bid_type === 1 ? 'tag-tongbu' : '',
                      item.bid_type === 2 ? 'tag-xianshi' : '',
                    ]"
                  >
                    <span class="tag-label"></span>
                    <!-- 同步拍 -->
                    <template v-if="item.bid_type === 1">
                      <!-- 进行中 -->
                      <span
                        class="tag-show-Live"
                        v-if="item.bid_status === 2 && item.status_text === ''"
                        ><img src="../../assets/img/list_live.gif"
                      /></span>
                      <!-- <span v-if="item.type == 1 && 
                                                item.bid_status === 2 &&
                                                item.live_status_text != ''"></span> -->
                      <!-- 拍卖中 即将开始 暂停中 -->
                      <span
                        class="tag-show tag-show-paimaizhong"
                        v-if="item.status_text != ''"
                      >
                        {{ item.status_text }}
                      </span>
                    </template>
                    <!-- 限时拍 -->
                    <template v-if="item.bid_type === 2">
                      <span class="tag-show tag-show-paimaizhong">{{
                        item.status_text
                      }}</span>
                    </template>
                  </div>
                </div>
                <div class="cover-picture">
                  <!-- 专场-同步拍-通交易-拍卖中
                    
                  -->
                  <lottie
                  v-if="
                      item.type == 1 &&
                        item.bid_type === 1 &&
                        item.bid_status === 2
                    "
                    class="breathe-wrap"
                    :options="breatheOptions"
                    :height="264"
                    :width="189"
                  />
                  <img :src="item.cover_pic" />
                  <!-- 拍卖会-不通交易 -->
                  <template v-if="
                      item.type === 2 &&
                        (item.bid_type != 1 ||
                        item.bid_type != 2)
                    ">
                    <div class="book-shadow-top"></div>
                    <div class="book-shadow-bottom"></div>
                  </template>
                  <p
                    :class="[
                      item.type === 2 &&
                      item.bid_type === 1 &&
                      item.bid_type === 2
                        ? 'show-time-small'
                        : 'show-time',
                    ]"
                   :style="item.auction_date.length>10? 'font-size: 13px;': '' " 
                  >
                  <!-- :style="" -->
                    {{ item.auction_date }}  
                  </p>
                </div>
              </div>
              <div class="focus-message">
                <p class="show-name">{{ item.name }}</p>
                <p class="show-address">{{ item.organ_name }}</p>
              </div>
              <div class="focus-option">
                <div
                  :class="[
                    'btnIcon bidBtn',
                    item.bid_type != 1 &&
                    item.bid_type != 2 &&
                    item.show_bid_label === 1
                      ? 'notActivated'
                      : '',
                  ]"
                >
                  <span
                    v-if="item.bid_type === 1 || item.bid_type === 2"
                    class="click-join"
                    ><i class="icon-hammer"></i>点击参拍</span
                  >
                  <span v-else>
                    <template v-if="item.show_bid_label === 1">
                      仅预展
                    </template>
                  </span>
                </div>
                <div
                  class="tag-butie"
                  v-if="item.max_commission_user_ratio != ''"
                >
                  补贴
                </div>
              </div>
            </div>
          </div>
        </div>

    </template>
    <template v-if="soonspecials.length">
        <h3 class="columnTit"><span>即将拍卖</span><a href="/preauction" target="_blank">查看更多</a></h3>
        <div class="auction-item-wrap" >
          <div
          class="auction-item"
            v-for="(item, itemIndex) in soonspecials"
            :key="itemIndex"
            @click="jumpSession(item)"
          >
            <div
              :class="[
                'focus-auction',
                itemIndex === 1 ? 'focus-auction-active' : '',
              ]"
            >
              <div class="auction-picture">
                <div class="auction-top-wrap">
                  <span
                    :class="[
                      'auction-top-tag',
                      item.bid_type === 1 ? 'tag-tongbu' : '',
                      item.bid_type === 2 ? 'tag-xianshi' : '',
                    ]"
                  ></span>
                  <span
                    class="tag-butie"
                    v-if="item.max_commission_user_ratio != ''"
                    >补贴</span
                  >
                  <!--  -->
                  <lottie
                    v-if="item.cultural_license != ''"
                    class="tag-wenwubaopi"
                    :options="wenwubaopiOptions"
                    :height="25"
                    :width="77"
                  />
                </div>
                <div class="cover-picture">
                  <img
                    :src="item.cover_pic || pictureDefault"
                    :class="[item.type === 2 ? '' : 'paimaihui-img']"
                  />
                  <template v-if="item.type === 2">
                    <div class="book-shadow-top"></div>
                    <div class="book-shadow-bottom"></div>
                  </template>
                </div>
                <div class="auction-bottom-wrap">
                  <div class="auction-bottom-time">{{ item.auction_date }}</div>
                </div>
              </div>
              <div class="focus-message">
                <p class="show-name">{{ item.name }}</p>
                <p class="show-address">{{ item.organ_name }}</p>
              </div>
            </div>
          </div>
        </div>

       
    </template>
    <template v-if="result.length">
        <h3 class="columnTit"><span>拍卖结果</span><a href="/result" target="_blank">查看更多</a></h3>
        <div class="aucResult">
            <div class="resultColTit flex">
                <span class="name">拍卖会名称</span>
                <span class="number">上拍/成交(件)</span>
                <span class="price">成交额(万)</span>
                <span class="company">拍卖公司</span>
                <span class="city">拍卖城市</span>
                <span class="time">拍卖日期</span>
            </div>
            <div class="collapseItem" v-for="(item,i) in result" :key="i" @mouseenter="hover" @mouseleave="leave">
                <div class="collapseHeader">
                    <div class="flex">
                        <span class="name">
                            <router-link target="_blank" :to="{
                                            name:'meeting_detail',
                                            parmas:{
                                                id:item.session_code
                                            }
                                        }"></router-link>
                            <a :href="'/meeting_detail/'+item.session_code" target="_blank">{{item.name}}</a>
                        </span>
                        <span class="number">

                            <i>{{item.total ? item.total.replace(new RegExp('件', 'g'), '') : '--'}}/</i>
                            <i >{{item.success_total ? item.success_total :'--'}}</i>

                        </span>
                        <span class="price">
                            <template v-if="isLogin==0">
                                <a @click="gotoLogin" href="javascript:;">登录后查看</a>
                            </template>
                            <template v-else>
                                <i class="red">{{item.total_price}}</i>
                            </template>
                        </span>

                        <a href="javascript:;" class="company" @click="gotoOrgan(item)"><i>{{item.organ_name}}</i>
                            <!-- <span class="comFlag">
                                <a style="border:0px" href="https://auction.artron.net/gongyue.php" v-if="item.IsZhongPai==1" target="_blank" class="flagText flagM" title="《中国文物艺术品拍卖企业自律公约》成员单位" >
                                        <img style="height: 17px;" src="@/assets/imgs/Frame540@2x.png" alt="" >
                                    </a>
                                    <i v-if="item.IsStandard==1" title="中国文物艺术品拍卖标准化达标企业" class="flagText flagM" >DB</i>
                                    <a href="https://auction.artron.net/help/introduce/html/introduce_brand.html" target="_blank" v-if="item.zone_name!=''" class="flagM"><img src="../../assets/imgs/zoom.png" alt="已开通官网"></a>
                             
                            </span> -->
                            <!--                                                <img :src="sessionList[0].imgUrl" alt="">-->
                        </a>

                        <span class="city">
                            <i>{{item.city ? item.city : '--'}}</i>
                        </span>
                        <span class="time">
                            <el-tooltip class="item" effect="dark" :content="item.auction_date ? item.auction_date : '--'" placement="top">
                                <i>{{item.auction_date ? item.auction_date : '--'}}</i>
                            </el-tooltip>
                        
                        </span>
                    </div>
                </div>
                <!-- <div class="sessionLink" v-if="item.specialsList.length">
                    <template v-for="(con,k) in Math.ceil(item.specialsList.length/2)">
                        <div class="fix" v-if="k<5" :key="k">
                            <template v-for="(ite,m) in item.specialsList">
                                <div class="sessionBox" :key="m" v-if="m>=(k*2) && m<(k+1)*2">
                                    <div class="sessionText">
                                        <a :href="'/special_detail/'+ite.specialCode" target="_blank" :class="{'hasLabel':ite && ite.label_list}">{{ite.name}}<template v-if="ite.total">（{{ite.total}}）</template></a>
                                    </div>

                                    <div class="flag" v-if="ite.label">
                                        <template v-for="(flag,n) in ite.label">
                                            <span :key="n" v-if="flag.name == '视频直播'" title="视频直播"><img src="../../assets/imgs/icon_videoLive.png"></span>
                                            <span :key="n" v-else-if="flag.name == '图文直播'" title="图文直播"><img src="../../assets/imgs/icon_imgLive.png"></span>
                                            <span :key="n" v-else-if="flag.name == '同步拍'" title="同步拍"><img src="../../assets/imgs/icon_tbp.png"></span>
                                            <span :key="n" v-else-if="flag.name == '限时拍'" title="限时拍"><img src="../../assets/imgs/icon_tbp.png"></span>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>

                </div> -->
            </div>
        </div>
    </template>
</div>
</template>

<script>
import lottie from '@/components/common/lottie'
const breathe_icon = require("../../assets/img/json/breathe_icon.json");
const liveIcon = require('@/assets/imgs/live_icon_2.json')
const wenwubaopi_icon = require("../../assets/img/json/wenwubaopi_icon.json");
const jingpai_icon = require("../../assets/img/json/jingpai_jin_icon.json");
const jinrijieshu_icon = require("../../assets/img/json/jinrijieshu_jin_icon.json");
const yuzhan_icon = require("../../assets/img/json/yuzhan_jin_icon.json");
import pictureDefault from "../../assets/img/home_picture_default@2x.png";
export default {
    props: ['onspecials', 'soonspecials', 'result', 'isLogin'],
    name: "indexSession",
    components: {
        lottie
    },
    data() {
        return {
          pictureDefault,
          jingpaiOptions: {
              animationData: jingpai_icon,
              loop: true,
              autoplay: true,
            },
            jieshuOptions: {
              animationData: jinrijieshu_icon,
              loop: true,
              autoplay: true,
            },
            yuzhanOptions: {
              animationData: yuzhan_icon,
              loop: true,
              autoplay: true,
            },
          wenwubaopiOptions: {
            animationData: wenwubaopi_icon,
            loop: true,
            autoplay: true,
          },
            heartOptions: {
                animationData: liveIcon,
                loop: true,
                autoplay: true,
            },
            breatheOptions: {
                animationData: breathe_icon,
                loop: true,
                autoplay: true,
            },
            activeName: '0',
            idx: {
                type: Number
            }
        }
    },
    methods: {
        jumpSession(item){
            if(item.type==1){
              window.location.href ='https://auction.artron.net/special_detail/'+item.source_code
            }else{
                window.location.href ='https://auction.artron.net/meeting_detail/'+item.source_code
            }
           
        },
        gotoOrgan(item) {
            if (item.zone_name != '') {
                window.location.href = '//auction.artron.net/' + item.zone_name
            } else {
                this.$router.push({
                    name: 'org_detail',
                    params: {
                        id: item.organ_code
                    }
                })
            }
        },
        hover(e) {
            let target = e.target
            target.classList.add('active')
        },
        leave(e) {
            let target = e.target
            target.classList.remove('active')
        },
        gotoLogin() {
            window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
        }
    }
}
</script>

<style lang="scss" scoped>
  .auction-item-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .auction-item {
      width:380px;
      margin: 0 20px 17px 0;
      position: relative;
      box-sizing: border-box;
      &:nth-child(2n) {
        margin-right: 0;
      }
      .auction-picture {
        position: relative;
        .auction-top-wrap {
          position: absolute;
          top: 10px;
          left:  10px;
          display: flex;
          z-index: 1;
          width: 100%;
          span {
            margin-right:4.2px;
          }
          .tag-butie {
            background-color: #fff1f2;
            border-radius: 100px;
            font-size: 14px;
            color: #ff0000;
            display: inline-block;
            padding: 2px 9px 0;
            font-weight: bold;
          }
          .auction-top-tag {
            width: 53px;
            height: 23px;
            display: inline-block;
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .tag-xianshi {
            background-image: url(../../assets/img/icon_xianshipai@2x.png);
          }
          .tag-tongbu {
            background-image: url(../../assets/img/icon_tongbupai@2x.png);
          }
          .tag-wenwubaopi {
            width: 77px;
            height: 25px;
            margin-right: 0;
            position: absolute;
            right: 20px;
          }
        }
        .auction-bottom-wrap {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 74px;
          line-height: 74px;
          padding: 0 6.6px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.6)
          );
          border-radius: 0rem 0rem 8.8px 8.8px;
          .auction-bottom-time {
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: normal;
            position: absolute;
            left: 8px;
            bottom: 7px;

          }
        }
        .cover-picture {
          position: relative;
          img {
            display: block;
            border-radius: 8px;
            width: 100%;
            height: 214px;
          }
          .book-shadow-top {
            width: 96%;
            height: 214px;
            position: absolute;
            top: 6px;
            left: 5.6px;
            background-color: rgba(136, 136, 136, 0.6);
            border-radius: 8.8px;
            z-index: -2;

          }
          .book-shadow-bottom {
            width: 93%;
            height: 214px;
            position: absolute;
            top: 10px;
            left: 11px;
            background-color: rgba(170, 170, 170, 0.4);
            border-radius: 8.8px;
            z-index: -3;
          }
        }
      }
      .focus-message {
        font-size:14px;
        color: #000000;
        margin-top: 10px;
        .show-address {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #6B6C6C;
          white-space: nowrap;
          overflow: hidden;
          position: relative;
        }
        p.show-address::after {
          content: "";
          position: absolute;
          right: 0;
          top: 0;
          width: 40px;
          height: 100%;
          background-image: -webkit-linear-gradient(
            left,
            rgba(255, 255, 255, 0),
            #fff
          );
          background-image: -o-linear-gradient(
            left,
            rgba(255, 255, 255, 0),
            #fff
          );
          background-image: -moz-linear-gradient(
            left,
            rgba(255, 255, 255, 0),
            #fff
          );
          background-image: linear-gradient(left, rgba(255, 255, 255, 0), #fff);
        }
        .show-name {
          font-weight: 400;
          font-size: 18px;
          color: #000000;
          white-space: nowrap;
          overflow: hidden;
          position: relative;
        }
        p.show-name::after {
          content: "";
          position: absolute;
          right: 0;
          top: 0;
          width: 40px;
          height: 100%;
          background-image: url(../../assets/img/icon_semi_transparent@2x.png);
          background-repeat: no-repeat;
          background-size: 100%;
        }
      }
    }
  }
/*拍品列表*/
.swipe-item-wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      height: 100%;
      .swipe-item {
        // width: calc((100% - 0.2rem) / 4);
        width: 180px;
       
        margin: 0px 20px 30px 0;
        position: relative;
        box-sizing: border-box;
        overflow: visible !important;
        z-index: 1;
        &:nth-child(4n) {
          margin-right: 0;
        }
        .focus-wrap {
          width: 100%;
          box-sizing: border-box;
          .focus-picture {
            position: relative;
            border-radius: 0.5px;
            overflow: visible !important;
            z-index: 2;
            .cover-picture {
              cursor: pointer;
              position: relative;
              overflow: visible !important;
              z-index: 3;
              .breathe-wrap {
                position: absolute;
                top: -10.4px;
                left: -6px;
                width: 112px;
                height: 144px;
                z-index: 10;
              }
              img {
                width: 100%;
                height: 240px;
                object-fit: cover;
                border-radius: 12px;
              }
              .book-shadow-top {
                width: 80%;
                height: 240px;
                position: absolute;
                top: 7px;
                left: 50%;
                margin-left: -40%;
                background-color: rgba(136, 136, 136, 0.4);
                border-radius: 5px;
                z-index: -2;
              }
              .book-shadow-bottom {
                width: 90%;
                height:  240px;
                position: absolute;
                top: 4px;
                left: 50%;
                margin-left: -45%;
                background-color: rgba(170, 170, 170, 0.6);
                border-radius: 5px;
                z-index: -3;
              }
            }
          }
          .focus-picture-small {
            width: 100px;
            .cover-picture {
              img {
                width:115.6px;
                height: 144px;
              }
            }
          }
          .tag-wrap {
            position: relative;
            z-index: 4;
            .tag-list {
              position: relative;
              .tag-label {
                width: 53px;
                height: 23px;
                display: inline-block;
                position: absolute;
                top: 10px;
                left:10px;
                background-size: 100%;
                background-repeat: no-repeat;
                z-index: 2;
              }
              span {
                display: block;
                text-align: center;
              }
              .tag-show {
                position: absolute;
                top: 10px;
                left: 59px;
                height: 22.2px;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
                font-size: 12px;
                font-weight: 600;
                white-space: nowrap;
                color: #000;
                background-color: #fff;
                padding: 1.6px 5px 1px 8px;;
                z-index: 1;
              }
              .tag-show-Live {
                position: absolute;
                top: 13px;
                right:11px;
                background-color: #f22c2c;
                border-radius:6.5px;
                width:24px;
                height:24px;
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                  height:15px;
                  width:15px;
                  border-radius: 0;
                  display: block;
                }
              }
            }
            .tag-tongbu {
              span.tag-label {
                background-image: url(../../assets/img/icon_tongbupai@2x.png);
              }
              .tag-show-paimaizhong {
                border: 1px solid #ff627a;
              }
            }
            .tag-xianshi {
              span.tag-label {
                background-image: url(../../assets/img/icon_xianshipai@2x.png);
              }
              .tag-show-paimaizhong {
                background-color: #fff;
                position: absolute;
                top: 10px;
                left: 59px;
                height: 22.2px;
                border: 1px solid #e4e9f5;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
                font-size: 12px;
                font-weight: 600;
                white-space: nowrap;
                color: #000;
                padding: 2px 5px 3px 8px;
                z-index: 1;
              }
            }
            .tag-wenwu {
              position: absolute;
              top: -37.4px;
              left: 5px;
            }
          }
        }
        .focus-message {
          margin: 8px 0 4.4px;
          p.show-name {
            font-size: 18px;
            color: #000000;
            white-space: nowrap;
            overflow: hidden;
            position: relative;
          }
          p.show-name::after {
            content: "";
            position: absolute;
            right: 0;
            top: 0;
            width: 40px;
            height: 100%;
            background-image: url(../../assets/img/icon_semi_transparent@2x.png);
            background-repeat: no-repeat;
            background-size: 100%;
          }
          .show-address {
           
            font-size: 16px;
            color: #6b6c6c;
          }
        }
        .focus-option {
          display: inline-block;
          position: relative;
          .tag-butie {
            position: absolute;
            right: -33px;
            top: -11px;
            background-color: #fff1f2;
            border-radius: 100px;
            font-size: 14px;
            color: #ff0000;
            display: inline-block;
            padding: 2px 9px;
            font-weight: bold;
          }
          .btnIcon {
            cursor: pointer;
            height: 32px;
            line-height:32px;
            padding: 0 12px 0 12px;
            font-size: 14px;
            border-radius: 56px;
            color: #ffffff;
            .svg {
              display: inline-block;
              vertical-align: middle;
            }
            .click-join {
              display: flex;
              align-items: center;
              i.icon-hammer {
                width: 13px;
                height: 13px;
                display: inline-block;
                background-image: url(../../assets/img/icon_hammer@2x.png);
                background-size: 13px 13px;
                background-repeat: no-repeat;
                margin-right: 2px;
              }
            }
          }
          .canpaiBtnIcon {
            background: #f6344b;
          }
          .bidBtn {
            background: #009b5f;
            box-shadow: 0px 5px 5px 0px rgba(0,96,59,0.15);
          }
          .notActivated {
            background-color: #EEEEEE;
            color: #6B6C6C;
            box-shadow: unset;
            padding: 0 20px;
          }
        }
        .show-time-small {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100px;
          height:37.8px;
          line-height:38px;
          font-size:14px;
          padding: 0 6.6px;
          color: #fff;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.6)
          );
          border-radius: 0 0 8.8px 8.8px;
        }
        .show-time {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 99%;
          height: 54px;
          line-height: 68px;
          font-size: 16px;
          padding: 0 10px;
          color: #fff;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.6)
          );
          border-radius: 0 0 8.8px 8.8px;
        }
      }
    }
.aucList {
    justify-content: flex-start;
    margin-bottom: 20px;

    li {
        width: 380px;
        margin-right: 20px;

        .flagLabel {
            margin-top: 10px;

            span {
                color: #999;
                background: rgba(140, 140, 140, 0.08);
                display: inline-block;
                font-size: 12px;
                padding: 0 4px;
                border-radius: 4px;
                margin-right: 6px;
                height: 18px;
                line-height: 18px;
            }

            span:last-child {
                margin-right: 0;
            }
        }

        .imgBox {
            width: 384px;
            height: 216px;
            border-radius: 12px;
            overflow: hidden;
            position: relative;

            .liveIcon {
                position: absolute;
                top: 10px;
                right: 10px;
                z-index: 3;
                font-size: 12px;
                color: #FFFFFF;
                background: rgba(0, 0, 0, 0.2);
                padding: 4px 10px;
                border-radius: 25px 25px 25px 25px;

                .liveIconSty {
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 4px;
                    background: #f6344b;
                    border-radius: 25px;
                    padding: 6px;
                }
            }

            .aucStatusBox {
                position: absolute;
                left: 10px;
                bottom: 10px;
                border-radius: 10px;
                background-color: rgba(0, 0, 0, .4);
                font-size: 0;
                height: 20px;

            }

            .aucLive {
                padding: 0 10px;
                background-color: #18BD6F;
                border-radius: 10px;
                color: #fff;
                font-size: 12px;
                display: inline-block;
                line-height: 18px;
                height: 20px;
            }

            .aucLive img {
                height: 10px;
            }

            .aucBegin {
                background-color: #000
            }

            .aucNum {
                padding: 0 10px 0 5px;
                color: #fff;
                font-size: 12px;
            }

            .bigFlag {
                position: absolute;
                background: url("../../assets/imgs/icon_list_HDpic_26@2x.png") no-repeat;
                background-size: 100% 100%;
                width: 35px;
                height: 20px;
                right: 0;
                top: 0;
            }
        }

        .aucInfo {
            .tit {
                font-weight: 600;
                font-size: 16px;
                color: #222222;
                margin-top: 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            p {
                line-height: 22px;
                font-size: 14px;
                color: #262626;
                margin-top: 10px;

                label {
                    color: #8C8C8C;
                }
            }

        }
    }

    li:last-child {
        margin-right: 0;
    }
}

/*拍卖结果*/
.aucResult {
    .resultColTit {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 14px;
    }

    .name {
        width: 228px;
        margin-right: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .number {
        width: 112px;
    }

    .price {
        width: 120px;
    }

    .collapseItem .red {
        color: #F5222D;
    }

    .company {
        width: 100px;

        img {
            height: 20px;
            margin-left: 5px;
        }
    }

    .city {
        width: 60px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .time {
        width: 130px;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .flagText {
        display: inline-block;
        width: 25px;
        line-height: 20px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        font-size: 12px;
        margin-left: 5px;
        margin-right: 2px;
        color: #8C8C8C
    }

    .collapseHeader {
        line-height: 22px;
        color: #262626;
        font-size: 14px;
        display: flex;
        align-items: center;
        padding: 19px 10px;
    }

    .sessionLink {
        border-top: 1px solid #D9D9D9;
        padding: 0 10px;

        .sessionBox {
            width: 49%;
            display: inline-block;
            color: rgba(0, 0, 0, .85);
            line-height: 22px;
            font-size: 14px;
            padding: 10px 0;

            .sessionText {
                width: 290px;
                display: inline-block;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                line-height: 14px;
            }
        }

        .sessionBox:before {
            width: 8px;
            height: 8px;
            margin-bottom: 3px;
            background-color: #329D15;
            display: inline-block;
            content: '';
            margin-right: 8px;
            border-radius: 50%;
        }

        .flag {
            display: inline-block;

            img {
                margin-right: 8px;
            }
        }
    }

    .collapseItem {
        height: 50px;
        overflow: hidden;
    }

    .active {
        background-color: #EAF5E7;
        height: auto
    }
}
</style>
